module.exports = __webpack_public_path__ + "static/img/size.c77e5b9c.svg";